module.exports = "<section class=\"masonry-grid\">\r\n    <div class=\"grid col-xs-12 row\">\r\n        <div class=\"grid-wrap col-xs-12 row mbp-fluid\">\r\n            <div class=\"image-wrap col-xs-12\" *ngFor=\"let image of images\">\r\n                <div class=\"image\" [style.background-image] = \"'url(' + image.image + ')'\"></div>\r\n            </div>\r\n        </div>\r\n    </div>\r\n</section>"


//////////////////
// WEBPACK FOOTER
// E:/MBP/BloomyNG/src/app/masonrygrid/masonrygrid.component.html
// module id = ../../../../../src/app/masonrygrid/masonrygrid.component.html
// module chunks = main